<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="mt-8">
    <div class="panel">
      <div class="panel-body">
        <div class="relative grid grid-cols-1 gap-x-14 md:grid-cols-2">
          <button type="button"
            class="absolute top-1 -left-1.5 flex items-center justify-center p-1.5 text-gray-400 hover:text-slate-500">
            <span class="sr-only">Previous month</span>
            <i class="fa-solid fa-chevron-left fa-xl" @click="prevMonth()"></i>
          </button>
          <button type="button"
            class="absolute top-1 -right-1.5 flex items-center justify-center p-1.5 text-gray-400 hover:text-slate-500">
            <span class="sr-only">Next month</span>
            <i class="fa-solid fa-chevron-right fa-xl" @click="nextMonth()"></i>
          </button>
          <section v-for="(month, monthIdx) in monthss" :key="monthIdx" :class="[
            monthIdx === months.length - 1 && 'hidden md:block',
            'text-center'
          ]">
            <h2 class="font-semibold text-gray-900">
              {{ monthss[monthIdx].name }}
            </h2>
            <div class="mt-6 grid grid-cols-8 text-xs leading-6 text-gray-500">
              <div>Sem</div>
              <div>Lu</div>
              <div>Ma</div>
              <div>Mi</div>
              <div>Ju</div>
              <div>Vi</div>
              <div>Sa</div>
              <div>Do</div>
            </div>
            <div class="isolate mt-2 grid grid-cols-8 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200" v-if="isLoaded(monthss[monthIdx])">
              <template v-for="(day, dayIdx) in month.days" :key="day.date">
                <div v-if="dayIdx % 7 == 0" :class="[
                  'bg-white text-gray-400 italic py-1.5',
                  dayIdx === 0 && 'rounded-tl-lg',
                  dayIdx === month.days.length - 7 && 'rounded-bl-lg'
                ]">
                  {{ this.dateFormatterWeek(day.date) }}
                </div>
                <div :class="[
                  day.isCurrentMonth
                    ? 'bg-white text-gray-900'
                    : 'bg-gray-50 text-gray-400',
                  dayIdx === 6 && 'rounded-tr-lg',
                  dayIdx === month.days.length - 1 && 'rounded-br-lg',
                  'relative py-1.5 hover:bg-slate-100 focus:z-10'
                ]">
                  {{ day.n_day }} {{}}
                  <template v-if="day.isCurrentMonth">
                    <div v-for="exportation in day.exportations" :key="exportation.id">
                      <exportation-details :exportation="exportation"
                        :link_color="`exportation_status_${exportation.status_id}_text_color`" />
                    </div>
                    <div v-for="container in day.containers" :key="container.id">
                      <container-details :container="container" icon="fa-solid fa-truck-container"
                        :link_color="`container_status_${container.status_id}_text_color`" />
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <loading-message v-else />
          </section>
        </div>

        <section class="mt-12">
          <ol class="mt-2 divide-y divide-slate-200 text-sm leading-6 text-gray-500">
            <template v-for="(month, monthIdx) in monthss" :key="monthIdx">
              <template v-for="day in month.days" :key="day.date">
                <li class="py-4 sm:flex hover:bg-slate-50" v-for="exportation in day.exportations" :key="exportation.id">
                  <time class="w-28 flex-none"><span class="italic">Sem {{ exportation.week }}</span>,
                    {{
                      dateFormatterDayMonthName(exportation.departured_at)
                    }}</time>
                  <p class="mt-2 w-60 flex-none font-semibold text-gray-900 sm:mt-0">
                    <exportation-details :exportation="exportation" :display_booking_code="true" icon="fa-solid fa-ship"
                      :link_color="`exportation_status_${exportation.status_id}_text_color`" />
                  </p>
                  <p class="w-28 flex-none sm:ml-6">
                    <exportation-status :status_id="exportation.status_id" />
                  </p>
                </li>
                <li class="py-4 sm:flex hover:bg-slate-50" v-for="container in day.containers" :key="container.id">
                  <time class="w-28 flex-none"><span class="italic">Sem {{ container.week }}</span>,
                    {{ dateFormatterDayMonthName(container.load_date) }}</time>
                  <p class="mt-2 w-60 flex-none font-semibold text-gray-900 sm:mt-0">
                    <container-details :container="container" :display_container_code="true"
                      icon="fa-solid fa-truck-container"
                      :link_color="`container_status_${container.status_id}_text_color`" />
                  </p>
                  <p class="w-28 flex-none sm:ml-6">
                    <container-status :status_id="container.status_id" />
                  </p>
                </li>
              </template>
            </template>
          </ol>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/es";

import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationDetails from "@/components/views/agro_exporter/production/shared/exportation/ExportationDetails.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
import ContainerDetails from "@/components/views/agro_exporter/production/shared/container/ContainerDetails.vue";
export default {
  name: "AEProductionQueryContainerExportBimonthlySchedule",
  components: {
    ExportationStatus,
    ExportationDetails,
    ContainerStatus,
    ContainerDetails
  },
  props: ["exportations", "containers", "schedule"],
  data() {
    return {
      reference_date: null,
      months: [
        {
          name: "January",
          days: [
            { date: "2021-12-27" },
            { date: "2021-12-28" },
            { date: "2021-12-29" },
            { date: "2021-12-30" },
            { date: "2021-12-31" },
            { date: "2022-01-01", isCurrentMonth: true },
            { date: "2022-01-02", isCurrentMonth: true },
            { date: "2022-01-03", isCurrentMonth: true },
            { date: "2022-01-04", isCurrentMonth: true },
            { date: "2022-01-05", isCurrentMonth: true },
            { date: "2022-01-06", isCurrentMonth: true },
            { date: "2022-01-07", isCurrentMonth: true },
            { date: "2022-01-08", isCurrentMonth: true },
            { date: "2022-01-09", isCurrentMonth: true },
            { date: "2022-01-10", isCurrentMonth: true },
            { date: "2022-01-11", isCurrentMonth: true },
            { date: "2022-01-12", isCurrentMonth: true, isToday: true },
            { date: "2022-01-13", isCurrentMonth: true },
            { date: "2022-01-14", isCurrentMonth: true },
            { date: "2022-01-15", isCurrentMonth: true },
            { date: "2022-01-16", isCurrentMonth: true },
            { date: "2022-01-17", isCurrentMonth: true },
            { date: "2022-01-18", isCurrentMonth: true },
            { date: "2022-01-19", isCurrentMonth: true },
            { date: "2022-01-20", isCurrentMonth: true },
            { date: "2022-01-21", isCurrentMonth: true },
            { date: "2022-01-22", isCurrentMonth: true },
            { date: "2022-01-23", isCurrentMonth: true },
            { date: "2022-01-24", isCurrentMonth: true },
            { date: "2022-01-25", isCurrentMonth: true },
            { date: "2022-01-26", isCurrentMonth: true },
            { date: "2022-01-27", isCurrentMonth: true },
            { date: "2022-01-28", isCurrentMonth: true },
            { date: "2022-01-29", isCurrentMonth: true },
            { date: "2022-01-30", isCurrentMonth: true },
            { date: "2022-01-31", isCurrentMonth: true },
            { date: "2022-02-01" },
            { date: "2022-02-02" },
            { date: "2022-02-03" },
            { date: "2022-02-04" },
            { date: "2022-02-05" },
            { date: "2022-02-06" }
          ]
        },
        {
          name: "February",
          days: [
            { date: "2022-01-31" },
            { date: "2022-02-01", isCurrentMonth: true },
            { date: "2022-02-02", isCurrentMonth: true },
            { date: "2022-02-03", isCurrentMonth: true },
            { date: "2022-02-04", isCurrentMonth: true },
            { date: "2022-02-05", isCurrentMonth: true },
            { date: "2022-02-06", isCurrentMonth: true },
            { date: "2022-02-07", isCurrentMonth: true },
            { date: "2022-02-08", isCurrentMonth: true },
            { date: "2022-02-09", isCurrentMonth: true },
            { date: "2022-02-10", isCurrentMonth: true },
            { date: "2022-02-11", isCurrentMonth: true },
            { date: "2022-02-12", isCurrentMonth: true },
            { date: "2022-02-13", isCurrentMonth: true },
            { date: "2022-02-14", isCurrentMonth: true },
            { date: "2022-02-15", isCurrentMonth: true },
            { date: "2022-02-16", isCurrentMonth: true },
            { date: "2022-02-17", isCurrentMonth: true },
            { date: "2022-02-18", isCurrentMonth: true },
            { date: "2022-02-19", isCurrentMonth: true },
            { date: "2022-02-20", isCurrentMonth: true },
            { date: "2022-02-21", isCurrentMonth: true },
            { date: "2022-02-22", isCurrentMonth: true },
            { date: "2022-02-23", isCurrentMonth: true },
            { date: "2022-02-24", isCurrentMonth: true },
            { date: "2022-02-25", isCurrentMonth: true },
            { date: "2022-02-26", isCurrentMonth: true },
            { date: "2022-02-27", isCurrentMonth: true },
            { date: "2022-02-28", isCurrentMonth: true },
            { date: "2022-03-01" },
            { date: "2022-03-02" },
            { date: "2022-03-03" },
            { date: "2022-03-04" },
            { date: "2022-03-05" },
            { date: "2022-03-06" },
            { date: "2022-03-07" },
            { date: "2022-03-08" },
            { date: "2022-03-09" },
            { date: "2022-03-10" },
            { date: "2022-03-11" },
            { date: "2022-03-12" },
            { date: "2022-03-13" }
          ]
        }
      ]
    };
  },
  created: function () {
    moment.locale(localStorage.getItem("user_language") || window.navigator.language || "es");
    let curret_date = new Date();
    this.reference_date = new Date(
      curret_date.getFullYear(),
      curret_date.getMonth(),
      1
    );
  },
  watch: {
    reference_date: function (newValue) {
      const current_date = moment(newValue);
      this.$emit('updateSchedule',
        {
          ...this.parseRequesterReference(current_date),
          sides: [
            this.parseRequesterReference(current_date.add(1, 'month'))
          ]
        }
      );
    },
  },
  methods: {
    nextMonth: function () {
      this.reference_date = moment(this.reference_date).add(1, "months");
    },
    prevMonth: function () {
      this.reference_date = moment(this.reference_date).subtract(1, "months");
    },
    isLoaded: function (month) {
      const year = (this.schedule || {})[month.year];
      const month_data = (year || {})[month.month];
      if (month_data) {
        return Boolean(month_data.containers || month_data.exportations);
      }
      return false;
    },
    parseRequesterReference: function(reference) {
      return { year: reference.year(), month: reference.month() + 1, }
    }
  },

  computed: {
    monthss: function () {
      let months = [];

      let name_0 = moment(this.reference_date).format("MMMM YYYY");
      let name_1 = moment(this.reference_date)
        .add(1, "months")
        .format("MMMM YYYY");

      let begin_weekday_0 = moment(this.reference_date).day();
      let begin_weekday_1 = moment(this.reference_date).add(1, "months").day();

      if (begin_weekday_0 == 0) {
        begin_weekday_0 = 7;
      }

      if (begin_weekday_1 == 0) {
        begin_weekday_1 = 7;
      }

      let t_days_0 = moment(this.reference_date)
        .add(1, "months")
        .subtract(1, "days")
        .date();
      let t_days_1 = moment(this.reference_date)
        .add(2, "months")
        .subtract(1, "days")
        .date();

      let end_weekday_0 = moment(this.reference_date)
        .add(1, "months")
        .subtract(1, "days")
        .day();
      let end_weekday_1 = moment(this.reference_date)
        .add(2, "months")
        .subtract(1, "days")
        .day();

      if (end_weekday_0 == 0) {
        end_weekday_0 = 7;
      }

      if (end_weekday_1 == 0) {
        end_weekday_1 = 7;
      }

      months[0] = {
        name: name_0,
        ...this.parseRequesterReference(moment(this.reference_date)),
        t_days: t_days_0,
        begin_weekday: begin_weekday_0,
        end_weekday: end_weekday_0,
        days: []
      };
      months[1] = {
        name: name_1,
        ...this.parseRequesterReference(moment(this.reference_date).add(1, 'months')),
        t_days: t_days_1,
        begin_weekday: begin_weekday_1,
        end_weekday: end_weekday_1,
        days: []
      };

      for (let m = 0; m <= 1; m++) {
        let dates = [];
        let current_reference_date = moment(this.reference_date).add(
          m,
          "months"
        );
        for (let i = 1; i < months[m].begin_weekday; i++) {
          let c_date = moment(current_reference_date).subtract(
            months[m].begin_weekday - i,
            "days"
          );
          dates.push({
            date: c_date,
            n_day: moment(c_date).format("DD"),
            isCurrentMonth: false
          });
        }

        for (let i = 1; i <= months[m].t_days; i++) {
          let c_date = moment(current_reference_date).add(i - 1, "days");

          let c_exp = [];
          let c_con = [];

          this.exportations.forEach(exportation => {
            if (
              this.dateFormatterYearMonthDay(exportation.departured_at) ==
              this.dateFormatterYearMonthDay(c_date)
            ) {
              c_exp.push(exportation);
            }
          });

          this.containers.forEach(container => {
            if (
              this.dateFormatterYearMonthDay(container.load_date) ==
              this.dateFormatterYearMonthDay(c_date)
            ) {
              c_con.push(container);
            }
          });

          dates.push({
            date: c_date,
            n_day: moment(c_date).format("DD"),
            isCurrentMonth: true,
            exportations: c_exp,
            containers: c_con
          });
        }

        for (let i = 1; i < 7 - months[m].end_weekday + 1; i++) {
          let c_date = moment(current_reference_date).add(
            months[m].t_days - 1 + i,
            "days"
          );
          dates.push({
            date: c_date,
            n_day: moment(c_date).format("DD"),
            isCurrentMonth: false
          });
        }

        months[m].days = dates;
      }
      return months;
    }
  }
};
</script>
